import type { Settings as LayoutSettings } from "@ant-design/pro-components";

const defaultSettings: LayoutSettings = {
  title: "平台后台",
  navTheme: "light",
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: true,
};

export default defaultSettings;
